<h2 mat-dialog-draggable-title mat-dialog-title>{{title | translate}}
    <button (click)="onNoClick()" aria-label="Close" cdkFocusInitial class="close" type="button">
      <span aria-hidden="true">&times;</span>
    </button>
  </h2>
  
  <mat-divider></mat-divider>
  <div>
    <form name="form" [formGroup]="actionForm" appFocusFirstElement>
        <div class="col-md-6 col-lg-12 mt-5">
            <mat-form-field class="mat-full-width">
                <mat-label>{{title | translate}}</mat-label>
                <textarea matInput
                        maxlength="1000"
                       [required]="isRequired"
                       (focusout)="onFocusReason()"
                       formControlName="content" type="text"></textarea>
                       <mat-error *ngIf="actionForm.invalid">
                        <span class="text-error">{{'approved.reject_form_validate' | translate}}</span>
                      </mat-error>
            </mat-form-field>
        </div>
    </form>
    <mat-dialog-actions align="center" class="pt-2 pb-3">
      <button mat-stroked-button color="primary" type="button" (click)="onCancel()" class="mr-2">
        <mat-icon class="mr-0">cancel</mat-icon>{{ "button.cancel" | translate }}
      </button>
      <button mat-raised-button color="primary" type="submit" (click)="onSave()" class="ml-2">
        <mat-icon class="mr-0">save</mat-icon>{{ "confirm" | translate }}
      </button>
    </mat-dialog-actions>
  </div>